<template>
	<div>
    <lk-form :label-width='134' label-position="right" :model='supplierForm'
      :rules="supplierValidate" ref="supplierInfoCheck" id='supplier' class="supplierComponents">
      <lk-card title='供应商信息' class="cardContainer">
        <lk-row :gutter='16'>
          <lk-col span='7'>
            <lk-form-item  label='供应商名称:' prop='name'>
              <InputSearch v-if='!disableSocialUnifyCreditCode&& isInStore' :loading='searchLoading'
                v-model.trim="supplierForm.name" :reset='false' :columns='searchColumns'
                @getData='handleSearch' :data='nameList' @selected='handleSelectName' :maxlength='35'></InputSearch>
              <lk-input :maxlength='35' v-else-if="able " class="supplier"
                @on-change="onNameChanged"
                v-model.trim="supplierForm.name">
              </lk-input>
              <span v-else>{{ supplierForm.name | defaultStr }}</span>


            </lk-form-item>
            <!-- <lk-form-item v-else label='供应商名称:' prop='name'>

            </lk-form-item> -->
          </lk-col>
          <lk-col span='7' offset='1'>
            <lk-form-item label='社会统一信用代码:' prop='socialUnifyCreditCode'>
              <lk-input :maxlength='18' placeholder='请输入'
                :disabled='disableSocialUnifyCreditCode' v-if="able"
                v-model.trim="supplierForm.socialUnifyCreditCode"></lk-input>
              <span v-else>{{ supplierForm.socialUnifyCreditCode | defaultStr }}</span>
            </lk-form-item>
          </lk-col>
        </lk-row>
        <lk-row :gutter='16'>
          <lk-col span='7'>
            <lk-form-item label='法人代表:' prop='corporationPerson'>
              <lk-input :maxlength='30' placeholder='请输入' v-if="able"
                v-model.trim="supplierForm.corporationPerson"></lk-input>
              <span v-else>{{ supplierForm.corporationPerson | defaultStr }}</span>
            </lk-form-item>
          </lk-col>
          <lk-col span='7' offset='1'>
            <lk-form-item label='助记码:' prop='memoryCode'>
              <lk-input :maxlength='30' placeholder='请输入' v-if="able"
                v-model.trim="supplierForm.memoryCode"></lk-input>
              <span v-else>{{ supplierForm.memoryCode | defaultStr }}</span>
            </lk-form-item>
          </lk-col>
        </lk-row>
        <lk-row :gutter='16'>
          <lk-col class="enterpriseTypeClass">
            <lk-form-item label='生产/经营范围:' prop='enterpriseType'>
              <lk-checkbox-group v-model="supplierForm.enterpriseType" @on-change="enterpriseTypeChange">
                <lk-checkbox v-for="(item, index) in enterpriseTypeList" :disabled='!able'
                  :label='index+1+""' :key="index">{{ item }}
                </lk-checkbox>
              </lk-checkbox-group>
            </lk-form-item>
          </lk-col>
        </lk-row>
        <lk-row :gutter='16'>
          <lk-col span='7'>
            <lk-form-item label='注册地址:' prop='locationArr'>
              <Location v-model="supplierForm.locationArr" v-if='able' @on-change='handleLocation'></Location>
              <span v-else>{{ supplierForm.locationStr | defaultStr }}</span>
            </lk-form-item>
          </lk-col>
          <lk-col span='7' offset='1'>
            <lk-form-item label='详细地址:' prop='rigistryAddress'>
              <lk-input :maxlength='100' placeholder='请输入' v-if="able"
                v-model.trim="supplierForm.rigistryAddress"></lk-input>
              <span v-else>{{ supplierForm.rigistryAddress | defaultStr }}</span>
            </lk-form-item>
          </lk-col>
        </lk-row>
        <lk-row :gutter='16'>
          <lk-col span='7' >
            <lk-form-item label='行政区划代码:' prop='regionCode'>
              <lk-input :maxlength='20' placeholder='请输入' v-if="able" ref='regionCode'
                v-model.trim="supplierForm.regionCode">
              </lk-input>
              <span
                v-else>{{ supplierForm.regionCode }}</span>
            </lk-form-item>
          </lk-col>
          <lk-col span='7' offset='1'>
            <lk-form-item label='注册资金:' prop='rigistryFund'>
              <lk-input :maxlength='20' placeholder='请输入' v-if="able"
                v-model.trim="supplierForm.rigistryFund"><span slot="append">万元</span>
              </lk-input>
              <span
                v-else>{{ supplierForm.rigistryFund?(supplierForm.rigistryFund+'万元'):'-' }}</span>
            </lk-form-item>
          </lk-col>

        <lk-col span='7'  offset='1'>
              <lk-form-item label='区域:' prop='area'>
                <lk-input :maxlength='100' placeholder='请输入' v-if="able"
                  v-model.trim="supplierForm.area"></lk-input>
                <span v-else>{{ supplierForm.area | defaultStr }}</span>
              </lk-form-item>
            </lk-col>
        </lk-row>
        <lk-row :gutter='16'> <lk-col span='7'>
            <lk-form-item label='质量负责人:' prop='qualityResponsible'>
              <lk-input :maxlength='30' placeholder='请输入' v-if="able"
                v-model.trim="supplierForm.qualityResponsible"></lk-input>
              <span v-else>{{ supplierForm.qualityResponsible | defaultStr }}</span>
            </lk-form-item>
          </lk-col>  <lk-col span='7' offset='1'>
            <lk-form-item label='邮编:' prop='postCode'>
              <lk-input :maxlength='6' placeholder='请输入' v-if="able"
                v-model.trim="supplierForm.postCode" number></lk-input>
              <span v-else>{{ supplierForm.postCode | defaultStr }}</span>
            </lk-form-item>
          </lk-col>

        </lk-row>
        <lk-row :gutter='16'>
          <lk-col class="backGroundCard rowTop" span='7' offset='16'>
            <lk-row>
              <lk-form-item prop='businessLicenceUrl'>
                <div class="label withPic">
                  <label>营业执照:</label>
                </div>
                <Uploader :able='able' v-model.trim="supplierForm.businessLicenceUrl">
                </Uploader>
              </lk-form-item>
            </lk-row>
            <lk-row>
              <lk-form-item label='有效期限:' prop='businessLicenceRange'>
                  <expire-picker :type='1' :able='able' :hasForever='true' :isRange='true'
                    :isForever='supplierForm.businessLicenceForever'
                    @handleForever='handleForever("businessLicenceForever",$event)'
                    v-model="supplierForm.businessLicenceRange"/>
              </lk-form-item>
            </lk-row>
            <lk-row>
              <lk-form-item label='发证机关:' prop='businessLicenceOffice'>
                <lk-input :maxlength='100' placeholder='请输入' v-if="able"
                  v-model.trim="supplierForm.businessLicenceOffice"></lk-input>
                <span v-else>{{ supplierForm.businessLicenceOffice | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
          </lk-col>
        </lk-row>
      </lk-card>

      <lk-card title='药品生产信息' class="cardContainer" v-if="supplierForm.enterpriseType.includes('2')">
        <lk-row :gutter='16'>
          <lk-col span='23'>
              <lk-row>
                <lk-form-item label='药品生产范围:' prop='drugProdScopeIds'>
                  <lk-select :maxlength='100' placeholder='请输入' v-if="able"
                    :multiple="true" :filterable="true"
                    v-model.trim="supplierForm.drugProdScopeIds">
                    <lk-option v-for="(item,index) in scopeLists.drugProdLabelList"
                      :value='item.id+""' :key="index">
                      {{ item.name }}
                    </lk-option>
                  </lk-select>
                  <span v-else>{{ supplierForm.drugProdScopes | defaultStr }}</span>
                </lk-form-item>
              </lk-row>
          </lk-col>
        </lk-row>
        <lk-row :gutter='16'>
          <lk-col class="backGroundCard" span='7'>
              <lk-row>
                <lk-form-item prop='drugProductCredentailUrl'>
                  <div class="label withPic">
                    <label>药品生产许可证:</label>
                  </div>
                  <Uploader :able='able' v-model.trim="supplierForm.drugProductCredentailUrl">
                  </Uploader>
                </lk-form-item>
              </lk-row>
              <lk-row>
                <lk-form-item prop='drugProductCredentailCode' label='证件号:'>
                  <lk-input :maxlength='100' placeholder='请输入' v-if="able"
                    v-model.trim="supplierForm.drugProductCredentailCode"></lk-input>
                  <span v-else>{{ supplierForm.drugProductCredentailCode | defaultStr }}</span>
                </lk-form-item>
              </lk-row>
              <lk-row>
                <lk-form-item label='有效日期:' prop='drugProductRange'>
                  <expire-picker :type='1' :able='able' :isRange='true' v-model="supplierForm.drugProductRange"/>
                </lk-form-item>
              </lk-row>
              <lk-row>
                <lk-form-item label='发证机关:' prop='drugProductOffice'>
                  <lk-input :maxlength='100' placeholder='请输入' v-if="able"
                    v-model.trim="supplierForm.drugProductOffice"></lk-input>
                  <span v-else>{{ supplierForm.drugProductOffice | defaultStr }}</span>
                </lk-form-item>
              </lk-row>
          </lk-col>
          <lk-col class="backGroundCard" span='7' offset='1'>
              <lk-row>
                <lk-form-item prop='gmpUrl'>
                  <div class="label withPic">
                    <label>GMP证书:</label>
                  </div>
                  <Uploader :able='able' v-model.trim="supplierForm.gmpUrl">
                  </Uploader>
                </lk-form-item>
              </lk-row>
              <lk-row>
                <lk-form-item prop='gmpCode' label='证件号:'>
                  <lk-input :maxlength='100' placeholder='请输入' v-if="able"
                    v-model.trim="supplierForm.gmpCode"></lk-input>
                  <span v-else>{{ supplierForm.gmpCode | defaultStr }}</span>
                </lk-form-item>
              </lk-row>
              <lk-row>
                <lk-form-item label='有效日期:' prop='gmpRange'>
                  <expire-picker  :disableInfo='true' :type='1' :able='able' :isRange='true' v-model="supplierForm.gmpRange"/>
                </lk-form-item>
              </lk-row>
              <lk-row>
                <lk-form-item label='发证机关:' prop='gmpCredentailOffice'>
                  <lk-input :maxlength='100' placeholder='请输入' v-if="able"
                    v-model.trim="supplierForm.gmpCredentailOffice"></lk-input>
                  <span v-else>{{ supplierForm.gmpCredentailOffice | defaultStr }}</span>
                </lk-form-item>
              </lk-row>
          </lk-col>
        </lk-row>
      </lk-card>

      <lk-card title='药品经营信息' class="cardContainer" v-if="supplierForm.enterpriseType.includes('1') || supplierForm.enterpriseType.includes('2')">
        <lk-row :gutter='16'>
          <lk-col span='23'>
            <lk-row>
              <lk-form-item label='药品经营范围:' prop='drugBizScopeIds'>
                <lk-select :maxlength='100' placeholder='请输入' v-if="able"
                  :multiple="true" :filterable="true"
                  v-model.trim="supplierForm.drugBizScopeIds">
                    <lk-option v-for="(item,index) in scopeLists.drugBizLabelList"
                      :value='item.id+""' :key="index">
                      {{ item.name }}
                    </lk-option>
                </lk-select>
                <span v-else>{{ supplierForm.drugBizScopes | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
          </lk-col>
        </lk-row>
        <lk-row :gutter='16' v-if="supplierForm.enterpriseType.includes('1')">
          <lk-col class="backGroundCard" span='7'>
            <lk-row>
              <lk-form-item prop='drugBusinessCredentailUrl'>
                <div class="label withPic">
                  <label>药品经营许可证:</label>
                </div>
                <Uploader :able='able' v-model.trim="supplierForm.drugBusinessCredentailUrl">
                </Uploader>
              </lk-form-item>
            </lk-row>
            <lk-row>
              <lk-form-item prop='drugBusinessCredentailCode' label='证件号:'>
                <lk-input :maxlength='20' placeholder='请输入' v-if="able"
                  v-model.trim="supplierForm.drugBusinessCredentailCode"></lk-input>
                <span v-else>{{ supplierForm.drugBusinessCredentailCode | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
            <lk-row>
              <lk-form-item label='有效日期:' prop='drugBusinessRange'>
                <expire-picker :type='1' :able='able' :isRange='true' v-model="supplierForm.drugBusinessRange"/>
              </lk-form-item>
            </lk-row>
            <lk-row>
              <lk-form-item label='发证机关:' prop='drugBusinessOffice'>
                <lk-input :maxlength='100' placeholder='请输入' v-if="able"
                  v-model.trim="supplierForm.drugBusinessOffice"></lk-input>
                <span v-else>{{ supplierForm.drugBusinessOffice | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
          </lk-col>
          <lk-col class="backGroundCard" span='7' offset='1'>
            <lk-row>
              <lk-form-item prop='gspUrl'>
                <div class="label withPic">
                  <label>GSP证书:</label>
                </div>
                <Uploader :able='able' v-model.trim="supplierForm.gspUrl">
                </Uploader>
              </lk-form-item>
            </lk-row>
            <lk-row>
              <lk-form-item prop='gspCode' label='证件号:'>
                <lk-input :maxlength='100' placeholder='请输入' v-if="able"
                  v-model.trim="supplierForm.gspCode"></lk-input>
                <span v-else>{{ supplierForm.gspCode | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
            <lk-row>
              <lk-form-item label='有效日期:' prop='gspRange'>
                <expire-picker :type='1'  :disableInfo='true' :able='able' :isRange='true' v-model="supplierForm.gspRange"/>
              </lk-form-item>
            </lk-row>
            <lk-row>
              <lk-form-item label='发证机关:' prop='gspCredentailOffice'>
                <lk-input :maxlength='100' placeholder='请输入' v-if="able"
                  v-model.trim="supplierForm.gspCredentailOffice"></lk-input>
                <span v-else>{{ supplierForm.gspCredentailOffice | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
          </lk-col>
        </lk-row>
      </lk-card>

      <lk-card title='食品信息' class="cardContainer" v-if="supplierForm.enterpriseType.includes('3')">
        <lk-row :gutter='16'>
          <lk-col class="backGroundCard" span='7'>
              <lk-row>
                <lk-form-item prop='foodCredentailUrl'>
                  <div class="label withPic">
                    <label>食品生产许可证:</label>
                  </div>
                  <Uploader :able='able' v-model.trim="supplierForm.foodCredentailUrl">
                  </Uploader>
                </lk-form-item>
              </lk-row>
              <lk-row>
                <lk-form-item prop='foodCredentailCode' label='证件号:'>
                  <lk-input :maxlength='100' placeholder='请输入' v-if="able"
                    v-model.trim="supplierForm.foodCredentailCode"></lk-input>
                  <span v-else>{{ supplierForm.foodCredentailCode | defaultStr }}</span>
                </lk-form-item>
              </lk-row>
              <lk-row>
                <lk-form-item label='有效日期:' prop='foodCredentailRange'>
                  <expire-picker :type='1' :able='able' :isRange='true' v-model="supplierForm.foodCredentailRange"/>
                </lk-form-item>
              </lk-row>
              <lk-row>
                <lk-form-item label='发证机关:' prop='foodCredentialOffice'>
                  <lk-input :maxlength='100' placeholder='请输入' v-if="able"
                    v-model.trim="supplierForm.foodCredentialOffice"></lk-input>
                  <span v-else>{{ supplierForm.foodCredentialOffice | defaultStr }}</span>
                </lk-form-item>
              </lk-row>
          </lk-col>
          <lk-col class="backGroundCard" span='7' offset='1'>
              <lk-row>
                <lk-form-item prop='foodBizUrl'>
                  <div class="label withPic">
                    <label>食品经营许可证:</label>
                  </div>
                  <Uploader :able='able' v-model.trim="supplierForm.foodBizUrl">
                  </Uploader>
                </lk-form-item>
              </lk-row>
              <lk-row>
                <lk-form-item prop='foodBizCode' label='证件号:'>
                  <lk-input :maxlength='100' placeholder='请输入' v-if="able"
                    v-model.trim="supplierForm.foodBizCode"></lk-input>
                  <span v-else>{{ supplierForm.foodBizCode | defaultStr }}</span>
                </lk-form-item>
              </lk-row>
              <lk-row>
                <lk-form-item label='有效日期:' prop='foodBizRange'>
                  <expire-picker :type='1' :able='able' :isRange='true' v-model="supplierForm.foodBizRange"/>
                </lk-form-item>
              </lk-row>
              <lk-row>
                <lk-form-item label='发证机关:' prop='foodBizOffice'>
                  <lk-input :maxlength='100' placeholder='请输入' v-if="able"
                    v-model.trim="supplierForm.foodBizOffice"></lk-input>
                  <span v-else>{{ supplierForm.foodBizOffice | defaultStr }}</span>
                </lk-form-item>
              </lk-row>
          </lk-col>
        </lk-row>
      </lk-card>

      <lk-card title='器械生产信息' class="cardContainer" v-if="supplierForm.enterpriseType.includes('4')">
        <lk-row :gutter='16'>
          <lk-col span='23'>
            <lk-row>
              <lk-form-item label='器械生产范围:' prop='equipmentProdScopeIds'>
                <lk-select :maxlength='100' placeholder='请输入' v-if="able"
                  :multiple="true" :filterable="true"
                  v-model.trim="supplierForm.equipmentProdScopeIds">
                  <lk-option v-for="(item,index) in scopeLists.equipmentProdLabelList"
                    :value='item.id+""' :key="index">
                    {{ item.name }}
                  </lk-option>
                </lk-select>
                <span v-else>{{ supplierForm.equipmentProdScopes | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
          </lk-col>
        </lk-row>
        <lk-row :gutter='16'>
          <lk-col class="backGroundCard" span='7'>
            <lk-row>
              <lk-form-item prop='equipmentProdUrl'>
                <div class="label withPic">
                  <label>医疗器械生产企业许可证:</label>
                </div>
                <Uploader :able='able' v-model.trim="supplierForm.equipmentProdUrl">
                </Uploader>
              </lk-form-item>
            </lk-row>
            <lk-row>
              <lk-form-item prop='equipmentProdCode' label='证件号:'>
                <lk-input :maxlength='100' placeholder='请输入' v-if="able"
                  v-model.trim="supplierForm.equipmentProdCode"></lk-input>
                <span v-else>{{ supplierForm.equipmentProdCode | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
            <lk-row>
              <lk-form-item label='有效日期:' prop='equipmentProdRange'>
                <expire-picker :type='1' :able='able' :isRange='true' v-model="supplierForm.equipmentProdRange"/>
              </lk-form-item>
            </lk-row>
            <lk-row>
              <lk-form-item label='发证机关:' prop='equipmentProdOffice'>
                <lk-input :maxlength='100' placeholder='请输入' v-if="able"
                  v-model.trim="supplierForm.equipmentProdOffice"></lk-input>
                <span v-else>{{ supplierForm.equipmentProdOffice | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
          </lk-col>
        </lk-row>
      </lk-card>

      <lk-card title='器械经营信息' class="cardContainer" v-if="supplierForm.enterpriseType.includes('5') || supplierForm.enterpriseType.includes('4')">
        <lk-row :gutter='16'>
          <lk-col span='23'>
            <lk-row>
              <lk-form-item label='器械经营范围:' prop='equipmentBizScopeIds'>
                <lk-select :maxlength='100' placeholder='请输入' v-if="able"
                  :multiple="true" :filterable="true"
                  @on-change='handlerEquipmentBizScope'
                  v-model.trim="supplierForm.equipmentBizScopeIds">
                  <lk-option v-for="(item,index) in scopeLists.equipmentBizLabelList"
                    :value='item.id+""' :key="index">
                    {{ item.name }}
                  </lk-option>
                </lk-select>
                <span v-else>{{ supplierForm.equipmentBizScopes | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
          </lk-col>
        </lk-row>
        <lk-row :gutter='16' v-if="supplierForm.enterpriseType.includes('5')">
          <lk-col class="backGroundCard" span='7'>
            <lk-row>
              <lk-form-item prop='secondMediEquiUrl' ref="secondMediEquiUrl">
                <div class="label withPic">
                  <label>二类医疗器械企业备案证书:</label>
                </div>
                <Uploader :able='able' v-model.trim="supplierForm.secondMediEquiUrl">
                </Uploader>
              </lk-form-item>
            </lk-row>
            <lk-row>
              <lk-form-item ref="secondMediEquiCode" prop='secondMediEquiCode' label='证件号:'>
                <lk-input :maxlength='100' placeholder='请输入' v-if="able"
                  v-model.trim="supplierForm.secondMediEquiCode"></lk-input>
                <span v-else>{{ supplierForm.secondMediEquiCode | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
            <lk-row>
              <lk-form-item ref="secondMediEquiCredDate" label='备案日期:' prop='secondMediEquiCredDate'>
                <timeStampDatePicker v-if="able" style="width:100%"
                  v-model="supplierForm.secondMediEquiCredDate"
                ></timeStampDatePicker>
                <span v-else>
                  {{ supplierForm.secondMediEquiCredDate | formatDate | defaultStr }}
                </span>
              </lk-form-item>
            </lk-row>
            <lk-row>
              <lk-form-item ref="secondMediEquiCredOffice" label='发证机关:' prop='secondMediEquiCredOffice'>
                <lk-input :maxlength='100' placeholder='请输入' v-if="able"
                  v-model.trim="supplierForm.secondMediEquiCredOffice"></lk-input>
                <span v-else>{{ supplierForm.secondMediEquiCredOffice | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
          </lk-col>
          <lk-col class="backGroundCard" span='7' offset='1'>
            <lk-row>
              <lk-form-item prop='thirdMediEquiUrl' ref="thirdMediEquiUrl">
                <div class="label withPic">
                  <label>三类医疗器械企业经营许可证:</label>
                </div>
                <Uploader :able='able' v-model.trim="supplierForm.thirdMediEquiUrl">
                </Uploader>
              </lk-form-item>
            </lk-row>
            <lk-row>
              <lk-form-item ref="thirdMediEquiCode" prop='thirdMediEquiCode' label='证件号:'>
                <lk-input :maxlength='100' placeholder='请输入' v-if="able"
                  v-model.trim="supplierForm.thirdMediEquiCode"></lk-input>
                <span v-else>{{ supplierForm.thirdMediEquiCode | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
            <lk-row>
              <lk-form-item ref="thirdMediEquiRange" label='有效期限:' prop='thirdMediEquiRange'>
                <expire-picker :type='1' :able='able' :isRange='true' v-model="supplierForm.thirdMediEquiRange"/>
              </lk-form-item>
            </lk-row>
            <lk-row>
              <lk-form-item ref="thirdMediEquiCredOffice" label='发证机关:' prop='thirdMediEquiCredOffice'>
                <lk-input :maxlength='100' placeholder='请输入' v-if="able"
                  v-model.trim="supplierForm.thirdMediEquiCredOffice"></lk-input>
                <span v-else>{{ supplierForm.thirdMediEquiCredOffice | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
          </lk-col>
        </lk-row>
      </lk-card>

      <lk-card title='化妆品信息' class="cardContainer" v-if="supplierForm.enterpriseType.includes('6')">
        <lk-row :gutter='16'>
          <lk-col class="backGroundCard" span='7'>
            <lk-row>
              <lk-form-item prop='cosmeticCredentailUrl'>
                <div class="label withPic">
                  <label>化妆品生产企业卫生许可证:</label>
                </div>
                <Uploader :able='able' v-model.trim="supplierForm.cosmeticCredentailUrl">
                </Uploader>
              </lk-form-item>
            </lk-row>
            <lk-row>
              <lk-form-item prop='cosmeticCredentailCode' label='证件号:'>
                <lk-input :maxlength='100' placeholder='请输入' v-if='able'
                  v-model.trim="supplierForm.cosmeticCredentailCode"></lk-input>
                <span v-else>{{ supplierForm.cosmeticCredentailCode | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
            <lk-row>
              <lk-form-item label='有效日期:' prop='cosmeticCredentailRange'>
                <expire-picker :type='1' :able='able' :isRange='true' v-model="supplierForm.cosmeticCredentailRange"/>
              </lk-form-item>
            </lk-row>
            <lk-row>
              <lk-form-item label='发证机关:' prop='cosmeticCredentailOffice'>
                <lk-input :maxlength='100' placeholder='请输入' v-if='able'
                  v-model.trim="supplierForm.cosmeticCredentailOffice"></lk-input>
                <span v-else>{{ supplierForm.cosmeticCredentailOffice | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
          </lk-col>
        </lk-row>
      </lk-card>

      <lk-card title='其他证件' class="cardContainer">
        <lk-row :gutter='16'>
          <lk-col class="backGroundCard" span='7'>
            <lk-row>
              <lk-form-item prop='otherCredentailUrl'>
                <div class="label withPic">
                  <label>证件1:</label>
                </div>
                <Uploader :able='able' v-model.trim="supplierForm.otherCredentailUrl">
                </Uploader>
              </lk-form-item>
            </lk-row>
            <lk-row>
              <lk-form-item prop='otherCredentailCode' label='证件号:'>
                <lk-input :maxlength='100' placeholder='请输入' v-if="able"
                  v-model.trim="supplierForm.otherCredentailCode"></lk-input>
                <span v-else>{{ supplierForm.otherCredentailCode | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
            <lk-row>
              <lk-form-item label='有效日期:' prop='otherCredentailRange'>
                <expire-picker :type='1' :able='able' :isRange='true' v-model="supplierForm.otherCredentailRange"/>
              </lk-form-item>
            </lk-row>
            <lk-row>
              <lk-form-item label='发证机关:' prop='otherCredentailOffice'>
                <lk-input :maxlength='100' placeholder='请输入' v-if="able"
                  v-model.trim="supplierForm.otherCredentailOffice"></lk-input>
                <span v-else>{{ supplierForm.otherCredentailOffice | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
          </lk-col>
          <lk-col class="backGroundCard" span='7' offset='1'>
            <lk-row>
              <lk-form-item prop='otherLicense2Url'>
                <div class="label withPic">
                  <label>证件2:</label>
                </div>
                <Uploader :able='able' v-model.trim="supplierForm.otherLicense2Url">
                </Uploader>
              </lk-form-item>
            </lk-row>
            <lk-row>
              <lk-form-item prop='otherLicense2Code' label='证件号:'>
                <lk-input :maxlength='100' placeholder='请输入' v-if="able"
                  v-model.trim="supplierForm.otherLicense2Code"></lk-input>
                <span v-else>{{ supplierForm.otherLicense2Code | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
            <lk-row>
              <lk-form-item label='有效日期:' prop='otherLicense2Range'>
                <expire-picker :type='1' :able='able' :isRange='true' v-model="supplierForm.otherLicense2Range"/>
              </lk-form-item>
            </lk-row>
            <lk-row>
              <lk-form-item label='发证机关:' prop='otherLicense2Office'>
                <lk-input :maxlength='100' placeholder='请输入' v-if="able"
                  v-model.trim="supplierForm.otherLicense2Office"></lk-input>
                <span v-else>{{ supplierForm.otherLicense2Office | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
          </lk-col>
        </lk-row>
      </lk-card>

      <lk-card title="详细信息" class="cardContainer" v-if="isInStore">
        <lk-row :gutter='16'>
          <lk-col span='7'>
            <lk-form-item label='是否仅供应援助药品:'>
              <lk-radio-group v-model='supplierForm.isAidOnly' @on-change='handleAidDrugChange'  v-if='able'>
                <lk-radio :label='1'>是</lk-radio>
                <lk-radio :label='2'>否</lk-radio>
              </lk-radio-group>

                  <span v-else>{{supplierForm.isAidOnly===1?'是':'否'  }}</span>
            </lk-form-item>
          </lk-col>
        </lk-row>
        <lk-row :gutter='16'>
          <lk-col span='7'>
              <lk-row>
                <lk-form-item label='开户银行:' prop='depositBank' v-if="showStoreItem">
                  <lk-input :maxlength='100' placeholder='请输入' v-if='able' style="width:100%"
                    v-model.trim="supplierForm.depositBank"></lk-input>
                  <span v-else>{{ supplierForm.depositBank | defaultStr }}</span>
                </lk-form-item>
              </lk-row>
          </lk-col>
          <lk-col span='7' offset='1'>
              <lk-row>
                <lk-form-item label='银行账号:' prop='bankAccount'  v-if="showStoreItem">
                  <lk-input :maxlength='30' placeholder='请输入' v-if='able' style="width:100%"
                    v-model.trim="supplierForm.bankAccount"></lk-input>
                  <span v-else>{{ supplierForm.bankAccount | defaultStr }}</span>
                </lk-form-item>
              </lk-row>
          </lk-col>
          <lk-col span='7' offset='1'>
              <lk-row>
                <lk-form-item label='账期:' prop='accountProid'>
                  <lk-input number :maxlength='5' placeholder='请输入数字' v-if='able' style="width:100%"
                    v-model.trim="supplierForm.accountProid">
                    <span slot="append">天</span>
                  </lk-input>
                  <span
                    v-else>{{(supplierForm.accountProid || supplierForm.accountProid ===0 ) ? (supplierForm.accountProid  +'天'):'-'}}</span>
                </lk-form-item>
              </lk-row>
          </lk-col>
        </lk-row>
        <lk-row :gutter='16'>
          <lk-col span='7'>
              <lk-row>
                <lk-form-item label='结账条件:' prop='closingCondition'>
                  <lk-select placeholder='请选择' v-if='able' style="width:100%"
                    v-model.trim="supplierForm.closingCondition">
                    <lk-option v-for="(item,index) in closingConditionList.slice(1)" :value='index+1'
                      :key="index">{{ item }}</lk-option>
                  </lk-select>
                  <span v-else>{{ closingConditionList[supplierForm.closingCondition] | defaultStr }}</span>
                </lk-form-item>
              </lk-row>
          </lk-col>
          <lk-col span='7' offset='1'>
              <lk-row>
                <lk-form-item label='赊款额上限:' prop='creditLimit'>
                  <lk-input :maxlength='10' number placeholder='请输入数字' v-if='able' style="width:100%"
                    v-model.trim="supplierForm.creditLimit">
                    <span slot="append">元</span></lk-input>
                  <span
                    v-else>{{(supplierForm.creditLimit || supplierForm.creditLimit === 0) ? (supplierForm.creditLimit +'元') : '-'}}</span>
                </lk-form-item>
              </lk-row>
          </lk-col>
          <lk-col span='7' offset='1'>
              <lk-row>
                <lk-form-item label='付款方式:' prop='payWay'>
                  <lk-select :maxlength='100' placeholder='请输入' v-if='able' style="width:100%"
                    v-model.trim="supplierForm.payWay">
                    <lk-option
                      v-for="(item) in payWayMap"
                      :key="item[0]"
                      :value="item[0]">{{ item[1] }}</lk-option>
                  </lk-select>
                  <span v-else>{{ payWayMap.get(supplierForm.payWay) | defaultStr }}</span>
                </lk-form-item>
              </lk-row>
          </lk-col>
        </lk-row>
        <lk-row :gutter='16'>
          <lk-col span='7'>
            <lk-row>
              <lk-form-item label='仓库地址:' prop='repositoryAddress'>
                <lk-input :maxlength='100' placeholder='请输入' v-if='able' style="width:100%"
                  v-model.trim="supplierForm.repositoryAddress"></lk-input>
                <span v-else>{{ supplierForm.repositoryAddress | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
          </lk-col>
          <lk-col span='7' offset='1'>
            <lk-row>
              <lk-form-item label='联系人:' prop='linkMan'>
                <lk-input :maxlength='30' placeholder='请输入' v-if='able' style="width:100%"
                  v-model.trim="supplierForm.linkMan"></lk-input>
                <span v-else>{{ supplierForm.linkMan | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
          </lk-col>
          <lk-col span='7' offset='1'>
            <lk-row>
              <lk-form-item label='电话:' prop='phone'>
                <lk-input :maxlength='30' placeholder='请输入' v-if='able' style="width:100%"
                  v-model.trim="supplierForm.phone"></lk-input>
                <span v-else>{{ supplierForm.phone | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
          </lk-col>
        </lk-row>
        <lk-row :gutter='16'>
          <lk-col span='7'>
            <lk-row>
              <lk-form-item label='传真:' prop='fax'>
                <lk-input :maxlength='30' placeholder='请输入' v-if='able' style="width:100%"
                  v-model.trim="supplierForm.fax"></lk-input>
                <span v-else>{{ supplierForm.fax | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
          </lk-col>
          <lk-col span='7' offset='1'>
            <lk-row>
              <lk-form-item prop='followGoodBillUrl' label='随货同行单:'>
                <Uploader :able='able' v-model.trim="supplierForm.followGoodBillUrl">
                </Uploader>
              </lk-form-item>
            </lk-row>
          </lk-col>
          <lk-col span='7' offset='1'>
           <lk-row>
            <lk-form-item prop='stampUrl' label='印章印模:'>
              <Uploader :able='able' v-model.trim="supplierForm.stampUrl"></Uploader>
            </lk-form-item>
          </lk-row>
          </lk-col>
        </lk-row>
        <lk-row :gutter='16'>
          <lk-col class="backGroundCard" span='7'>
            <lk-row>
              <lk-form-item prop='qualityEnsureProtocolUrl'>
                <div class="label withPic">
                  <label>质量保证协议:</label>
                </div>
                <Uploader :able='able' v-model.trim="supplierForm.qualityEnsureProtocolUrl">
                </Uploader>
              </lk-form-item>
            </lk-row>
            <lk-row>
              <lk-form-item label='质保协议有效期:' prop='qualityEnsureEffecivePeroid'  v-if="showStoreItem">
                <expire-picker :able='able'  v-model="supplierForm.qualityEnsureEffecivePeroid"/>
              </lk-form-item>
            </lk-row>
          </lk-col>
          <lk-col class="backGroundCard" span='7' offset='1'>
              <lk-row>
                <lk-form-item prop='authorizerBookUrl'>
                  <div class="label withPic">
                    <label>授权书:</label>
                  </div>
                  <Uploader :able='able' v-model.trim="supplierForm.authorizerBookUrl">
                  </Uploader>
                </lk-form-item>
              </lk-row>
              <lk-row>
                <lk-form-item label='授权书有效期:' prop='authorizerEffecivePeroid'  v-if="showStoreItem">
                  <expire-picker :able='able'  v-model="supplierForm.authorizerEffecivePeroid"/>
                </lk-form-item>
              </lk-row>
          </lk-col>
          <lk-col span='7' offset='1'>
            <lk-row>
              <lk-form-item label='文件归档编号:' prop='filedDocCode'>
                <lk-input :maxlength='100' placeholder='请输入' v-if='able' style="width:100%"
                  v-model.trim="supplierForm.filedDocCode"></lk-input>
                <span v-else>{{ supplierForm.filedDocCode | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
            <lk-row>
              <lk-form-item label='合格供应商档案表:' prop='qualitiedSupplierTable'>
                <lk-input :maxlength='100' placeholder='请输入' v-if='able' style="width:100%"
                  v-model.trim="supplierForm.qualitiedSupplierTable"></lk-input>
                <span v-else>{{ supplierForm.qualitiedSupplierTable | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
          </lk-col>
        </lk-row>
        <lk-row :gutter='16'>
          <lk-col span='7'>
            <lk-row>
              <lk-form-item label='受托人姓名:' prop='depositaryName'  v-if="showStoreItem">
                <lk-input :maxlength='30' placeholder='请输入' v-if='able' style="width:100%"
                  v-model.trim="supplierForm.depositaryName"></lk-input>
                <span v-else>{{ supplierForm.depositaryName | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
          </lk-col>
          <lk-col span='7' offset='1'>
            <lk-row>
              <lk-form-item label='受托人身份证号:' prop='depositaryIdCard'  v-if="showStoreItem">
                <lk-input :maxlength='18' placeholder='请输入' v-if='able' style="width:100%"
                  v-model.trim="supplierForm.depositaryIdCard"></lk-input>
                <span v-else>{{ supplierForm.depositaryIdCard | defaultStr}}</span>
              </lk-form-item>
            </lk-row>
          </lk-col>
          <lk-col span='7' offset='1'>
            <lk-row>
              <lk-form-item label='受托人身份证有效期:' prop='depositaryIdEffecivePeroid'  v-if="showStoreItem">
                <expire-picker :able='able'  v-model="supplierForm.depositaryIdEffecivePeroid"/>
              </lk-form-item>
            </lk-row>
          </lk-col>
        </lk-row>
        <lk-row :gutter='16'>
          <lk-col span='7'>
            <lk-row>
              <lk-form-item label='业务员备案情况:' prop='filedDocState'>
                <lk-input :maxlength='100' placeholder='请输入' v-if='able' style="width:100%"
                  v-model.trim="supplierForm.filedDocState"></lk-input>
                <span v-else>{{ supplierForm.filedDocState | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
          </lk-col>
          <lk-col span='7' offset='1'>
            <lk-row>
              <lk-form-item label='备案有效日期:' prop='filedDocEffecivePeroid'>
                <expire-picker :able='able'  v-model="supplierForm.filedDocEffecivePeroid"/>
              </lk-form-item>
            </lk-row>
          </lk-col>
          <lk-col span='7' offset='1'>
            <lk-row>
              <lk-form-item label='采购员意见:' prop='puchasePersonSuggestion'  v-if="showStoreItem">
                <lk-input :maxlength='100' placeholder='请输入' v-if='able' style="width:100%"
                  v-model.trim="supplierForm.puchasePersonSuggestion"></lk-input>
                <span v-else>{{ supplierForm.puchasePersonSuggestion | defaultStr }}</span>
              </lk-form-item>
            </lk-row>
          </lk-col>
          <lk-col span='7' v-if="!isEdit">
            <lk-row>
              <lk-form-item label='质量信誉考察意见:'>
                <span>{{this.supplierForm.qualityOpinionName}}</span>
              </lk-form-item>
            </lk-row>
          </lk-col>
        </lk-row>
      </lk-card>
    </lk-form>
    <DTPModal v-model="socialCodeModal" :content='socialCodeModalContent'
      @confirm='importInfo' confirmText='确定' @handleCancel='confirmClear' type='alert'>
    </DTPModal>

    <DTPModal v-model="inList" content='此供应商在门店供应商列表中已存在，是否前往编辑？' @confirm='inListConfirm'
      @handleCancel='confirmClear' confirmText='编辑' type='alert'></DTPModal>

    <DTPModal v-model="inListInJudge" content='此供应商在门店供应商列表中已存在，正在审批中，是否前往查看？'
      @confirm='inListInJudgeConfirm' @handleCancel='confirmClear' confirmText='查看' type='alert'>
    </DTPModal>

    <DTPModal v-model="disableItem" content='该供应商目前为禁用状态，无法引用' @confirm='confirmClear'
      :noCancel='true' type='alert'></DTPModal>

    <DTPModal v-model="editInfo" content='若对 “基本信息”和“证件信息”进行了修改，企业负责人审批通过后资料管理员进行审核方能生效' :noCancel='true'
      @confirm='editInfoConfirm' type='alert'>
    </DTPModal>

    <DTPModal v-model="inBaseList" content='此供应商在基础供应商列表中存在，是否引用？'
      @confirm='referenceConfirm' @handleCancel='confirmClear' confirmText='引用' type='alert'>
    </DTPModal>

	</div>
</template>
<script>
/* eslint-disable no-restricted-globals */
import Uploader from './Uploader.vue';
import utils from '../libs/utils';
import permission from '../mixins/permission';
import supplier from '../services/supplier';
import system from '../services/system';
import ExpirePicker from './expireInfo/expirePicker.vue';
import InputSearch from './InputSearch.vue';
import DTPModal from './DTPModal.vue';
import Location from './location.vue';


export default {
  name: 'supplier',
  mixins: [permission],
  components: {
    Uploader, DTPModal, ExpirePicker, InputSearch, Location,
  },
  props: {
    info: {
      type: Object,
    },
    // permissionList: {
    //   type: Array,
    // },
    scopeLists: {
      type: Object,
    },
    able: {
      type: Boolean,
    },
    baseData: {
      type: Object,
    },
    isInStore: {
      type: Boolean,
      default: false,
    },
    isImport: {
      type: Boolean,
    },
  },
  model: {
    prop: 'info',
    event: 'change',
  },
  watch: {
    info: {
      handler() {
        this.supplierForm = this.info;
      },
      deep: true,
    },
    supplierForm: {
      handler() {
        if (this.able && this.isInStore) {
          const ruleValidateIsChange = (this.supplierValidate.businessLicenceRange[0].required !== this.supplierForm.businessLicenceForever);
          this.supplierValidate.businessLicenceRange[0].required = !this.supplierForm.businessLicenceForever;
          if (!ruleValidateIsChange) {
            this.$refs.supplierInfoCheck.validateField('businessLicenceRange');
          }
        }
        if (this.setLeave && this.$route.name != 'approvalEdit') {
          this.$store.commit('setLeaveModal', true);
        }
      },
      deep: true,
    },
  },
  computed: {
    class2Instruments() { // 二类医疗器械经营范围
      const filterList = this.scopeLists.equipmentBizLabelList.filter(item => item.quaRequirements === 1);
      return filterList.map(item => item.id);
    },
    class3Instruments() { // 三类医疗器械经营范围
      const filterList = this.scopeLists.equipmentBizLabelList.filter(item => item.quaRequirements === 2);
      return filterList.map(item => item.id);
    },
    enterpriseTypeNames() {
      if (this.supplierForm.enterpriseType.map) {
        const resArr = this.supplierForm.enterpriseType.map(item => this.enterpriseTypeList[item - 1]);
        return resArr.join(';');
      }
      return '';
    },
    payWayMap() {
      return this.$store.state.publicParams.payWayMap;
    },
    // onlyAidDrug() {
    //   return this.supplierForm.isAidOnly === 1;
    // },
  },
  data() {
    return {
      isEdit: this.$route.name === 'supplierStoreEdit',
      showStoreItem: true,
      setLeave: false,
      datePickerPlacement: 'bottom-end',
      disableCodeCheck: false,
      inListInJudge: false,
      disableSocialUnifyCreditCode: false,
      disableItem: false,
      nameList: [], // 供应商名称下拉选择
      selectedIndex: null,
      socialCodeModal: false,
      editInfo: false,
      inList: false,
      inBaseList: false,
      dropdownVisible: false,
      socialCodeModalContent: '',
      enterpriseTypeList: ['药品经营', '药品生产', '食品（生产、经营）', '器械生产', '器械经营', '化妆品及其他'],
      supplierForm: {
        id: '', // 主键
        memoryCode: '', // 助记码
        code: '', // 供应商编码
        name: '', // 供应商名称
        status: '', // 单据状态（1:启用；2:禁用；3:删除）
        rigistryFund: '', // 注册资金
        area: '', // 区域
        postCode: '', // 邮编
        qualityResponsible: '', // 质量负责人
        enterpriseType: [], // 企业类型
        corporationPerson: '', // 企业法人
        locationArr: [], // 注册地址
        rigistryAddress: '', // 详细地址
        socialUnifyCreditCode: '', // 社会统一信用代码
        businessLicenceUrl: '', // 营业执照url
        businessLicenceRange: [],
        businessLicenceDate: '', // 营业执照发证日期 +
        businessLicenceEffecivePeroid: '', // 营业执照有效日期 +
        businessLicenceOffice: '', // 营业执照发证机关 +
        businessLicenceForever: false, // 营业执照永久 +

        drugProdScopeIds: '', // 药品生产范围
        drugProductCredentailCode: '', // 药品生产许可证号
        drugProductCredentailUrl: '', // 药品生产许可证证件照url
        drugProductRange: [], // 药品生产期限
        drugProductDate: '', // 药品生产许可证发证日期
        drugProductEffecivePeroid: '', // 药品生产许可证有效期限
        drugProductOffice: '', // 药品生产许可证发证机关
        gmpCode: '',
        gmpUrl: '', // gmp证书证件照url
        gmpRange: [], // gmp证书证件
        gmpCredentailDate: '', // gmp证书发证日期
        gmpEffecivePeroid: '', // gmp证书有效期限
        gmpCredentailOffice: '', // gmp证书发证机关

        drugBizScopeIds: '', // 药品经营范围
        drugBusinessCredentailUrl: '', // 药品经营许可证证件照url
        drugBusinessCredentailCode: '',
        drugBusinessRange: [], // 药品经营许可证证件照url
        drugBusinessEffecivePeroid: '', // 药品经营许可证有效期限
        drugBusinessOffice: '', // 药品经营许可证发证机关
        drugBusinessDate: '', // 药品经营许可证发证日期
        gspUrl: '', // gsp证书证件照url
        gspCode: '',
        gspRange: [], // gsp证书证件
        gspCredentailOffice: '', // gsp证书发证机关
        gspCredentailDate: '', // gsp证书发证日期
        gspEffecivePeroid: '', // gsp证书有效期限

        equipmentProdScopeIds: '',
        equipmentProdUrl: '',
        equipmentProdCode: '',
        equipmentProdRange: [],
        equipmentProdDate: '',
        equipmentProdExpiry: '',
        equipmentProdOffice: '',

        equipmentBizScopeIds: '',
        secondMediEquiCode: '', // 二类医疗器械生产（经营）企业许可证号
        secondMediEquiUrl: '', // 二类医疗器械生产（经营）企业许可证证件照url
        secondMediEquiCredOffice: '', // 二类医疗器械生产（经营）许可证发证机关
        secondMediEquiCredDate: null, // 二类医疗器械生产（经营）许可证发证日期

        thirdMediEquiCode: '', // 三类医疗器械生产（经营）企业许可证号
        thirdMediEquiUrl: '', // 三类医疗器械生产（经营）企业许可证证件照url
        thirdMediEquiRange: [], // 三类医疗器械生产（经营）企业许可证证件照url
        thirdMediEquiEffecPeroid: '', // 三类医疗器械生产（经营）许可证有效期限
        thirdMediEquiCredOffice: '', // 三类医疗器械生产（经营）许可证发证机关
        thirdMediEquiCredDate: '', // 三类医疗器械生产（经营）许可证发证日期

        foodCredentailCode: '', // 食品生产许可证号
        foodCredentailUrl: '', // 食品生产许可证证件照url
        foodCredentailRange: [], // 食品生产许可证证件照url
        foodEffecivePeroid: '', // 食品生产许可证有效期限
        foodCredentialOffice: '', // 食品生产许可证发证机关
        foodCredentailDate: '', // 食品生产许可证发证日期

        foodBizUrl: '',
        foodBizExpiry: '',
        foodBizOffice: '',
        foodBizDate: '',
        foodBizCode: '',
        foodBizRange: [],

        cosmeticCredentailUrl: '', // 化妆品生产企业卫生许可证证件照url
        cosmeticCredentailCode: '', // 化妆品生产企业卫生许可证号
        cosmeticCredentailOffice: '', // 化妆品生产企业卫生许可证发证机关
        cosmeticCredentailRange: [],
        cosmeticCredentailDate: '',
        cosmeticCredentailPeroid: '',

        otherCredentailUrl: '', // 其他证件证件照url
        otherCredentailCode: '', // 其他证件证件证号
        otherCredentailOffice: '', // 其他证件证件发证机关
        otherCredentailRange: [],
        otherCredentailDate: '',
        otherCredentailPeroid: '',

        otherLicense2Url: '',
        otherLicense2Code: '',
        otherLicense2Office: '',
        otherLicense2Range: [],
        otherLicense2Date: '',
        otherLicense2Expiry: '',

        depositBank: '', // 开户行
        repositoryAddress: '', // 仓库地址
        bankAccount: '', // 银行账号
        qualityEnsureProtocolCode: '', // 质量保证协议编号
        qualityEnsureProtocolUrl: '', // 质量保证协议url
        qualityEnsureEffecivePeroid: '', // 质量协议有效期限
        // authorizerName: '', // 授权人姓名
        authorizerEffecivePeroid: '', // 授权书有效期至
        depositaryName: '', // 受托人姓名
        depositaryIdCard: '', // 受托人身份证号
        depositaryIdEffecivePeroid: '', // 受托人身份证有效期限
        followGoodBillCode: '', // 随货通行单单据号
        followGoodBillUrl: '', // 随货通行单单据照url
        stampCode: '', // 印章印模编号
        stampUrl: '', // 印章印模url
        filedDocCode: '', // 文件归档编号
        filedDocState: '', // 业务员备案情况
        filedDocEffecivePeroid: '', // 备案有效期
        qualitiedSupplierTable: '', // 合格供应商档案表
        puchasePersonSuggestion: '', // 采购员意见
        storeId: '',
        storeName: '',
        createUserId: '',
        createUserName: '',
        createTime: '',
        refOriginId: '',
        accountProid: '',
        payWay: '',
        creditLimit: '',
        authorizerBookUrl: '',
      },
      closingConditionList: ['', '月结', '现款', '实销实结', '压批', '代销', '预付'],
      supplierValidate: {

      },
      searchColumns: [
        { title: '供应商名称', key: 'name', width: '100px' },
        { title: '社会统一码', key: 'socialUnifyCreditCode', width: '180px' },
        { title: '助记码', key: 'memoryCode', width: '100px' },
        { title: '企业法人', key: 'corporationPerson', width: '80px' },
      ],
      searchLoading: false,

    };
  },
  methods: {
    handlerEquipmentBizScope() {
      const hasClassII = this.findSomeNume(this.supplierForm.equipmentBizScopeIds, this.class2Instruments);
      const hasClassIII = this.findSomeNume(this.supplierForm.equipmentBizScopeIds, this.class3Instruments);
      if (this.isInStore) {
        if (hasClassII) {
          this.supplierValidate.secondMediEquiCode = [
            { required: true, message: '此处为必填项，不能为空。', trigger: 'change' },
          ];
          this.supplierValidate.secondMediEquiCredDate = [
            {
              required: true, message: '此处为必填项，不能为空。', trigger: 'change', type: 'number',
            },
          ];
          this.supplierValidate.secondMediEquiCredOffice = [
            { required: true, message: '此处为必填项，不能为空。', trigger: 'change' },
          ];
          this.supplierValidate.secondMediEquiUrl = [
            { required: true, message: '请上传证书', trigger: 'change' },
          ];
          this.$nextTick(() => {
            this.$refs.secondMediEquiUrl.isRequired = true;
            this.$refs.secondMediEquiCode.isRequired = true;
            this.$refs.secondMediEquiCredDate.isRequired = true;
            this.$refs.secondMediEquiCredOffice.isRequired = true;
          });
        } else {
          const list = ['secondMediEquiCode', 'secondMediEquiCredDate', 'secondMediEquiCredOffice', 'secondMediEquiUrl'];
          this.handlerValidateStatus(list);
        }
        if (hasClassIII) {
          this.supplierValidate.thirdMediEquiCode = [
            { required: true, message: '此处为必填项，不能为空。', trigger: 'change' },
          ];
          this.supplierValidate.thirdMediEquiRange = [
            {
              required: true, message: '此处为必填项，不能为空。', trigger: 'change', type: 'array',
            },
          ];
          this.supplierValidate.thirdMediEquiCredOffice = [
            { required: true, message: '此处为必填项，不能为空。', trigger: 'change' },
          ];
          this.supplierValidate.thirdMediEquiUrl = [
            { required: true, message: '请上传证书', trigger: 'change' },
          ];
          this.$nextTick(() => {
            this.$refs.thirdMediEquiUrl.isRequired = true;
            this.$refs.thirdMediEquiCode.isRequired = true;
            this.$refs.thirdMediEquiRange.isRequired = true;
            this.$refs.thirdMediEquiCredOffice.isRequired = true;
          });
        } else {
          const list = ['thirdMediEquiCode', 'thirdMediEquiRange', 'thirdMediEquiCredOffice', 'thirdMediEquiUrl'];
          this.handlerValidateStatus(list);
        }
      }
    },
    findSomeNume(idList, classArr) {
      let isSame = false;
      const length = idList.length;
      if (length) {
        for (let i = 0; i < length; i++) {
          const equipmentBizScopeId = Number(idList[i]);
          isSame = classArr.includes(equipmentBizScopeId);
          if (isSame) break;
        }
      }
      return isSame;
    },
    handlerValidateStatus(list) {
      list.forEach((name) => {
        this.supplierValidate[name] = [];
        this.$nextTick(() => {
          this.$refs[name].isRequired = false;
          this.$refs[name].validateMessage = '';
          this.$refs[name].validateState = '';
        });
      });
    },
    handleLocation(val) {
      console.log(val);
      const [provinceId, cityId, countyId] = val;
      this.supplierForm.provinceId = provinceId || '';
      this.supplierForm.cityId = cityId || '';
      this.supplierForm.countyId = countyId || '';

      if (!val.length) {
        return;
      }

      system.getRegionById({ id: countyId }).then((res) => {
        if (res.data.status === 200) {
          this.$refs.regionCode.currentValue = res.data.data.code;// 手动setinputvalue

          this.$set(this.supplierForm, 'regionCode', res.data.data.code);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
      // 后端请求处理行政区划代码
    },
    handleAidDrugChange(val) {
      const nameArr = [
        'depositBank',
        'qualityEnsureEffecivePeroid',
        'authorizerEffecivePeroid',
        'depositaryName',
        'depositaryIdCard',
        'depositaryIdEffecivePeroid',
        'puchasePersonSuggestion',
        'bankAccount',
      ];
      nameArr.forEach((key) => {
        // debugger;
        // console.log(this.supplierValidate[key]);

        this.supplierValidate[key].forEach((item) => {
          if (!item.validator) {
            item.required = val !== 1;
          }
        });
      });
      this.showStoreItem = false;// 重置相关项


      this.$nextTick(() => {
        this.showStoreItem = true;
      });
    },
    bankAccountTest(rule, value, callback) {
      if (value) {
        if (/^(\d|[a-z]|[A-Z])+$/.test(value)) {
          callback();
        } else {
          callback(new Error('请输入正确的银行账号'));
        }
      }
      callback();
    },
    codeTest(rule, value, callback) { // 验证社会统一验证码
      this.$store.commit('setDisableLoading', true);
      this.disableCodeCheck = !this.$route.name.endsWith('Add'); // 禁用社会统一信用码检查 新建需检查
      if (!this.disableSocialUnifyCreditCode && !this.disableCodeCheck) {
        if (!/(\d|[a-z]|[A-Z]){18}/.test(value)) {
          callback(new Error('请输入正确的社会统一信用代码'));
        }
        supplier.supplierSocialCodeCheck({
          socialCode: value,
          originType: this.isInStore ? 2 : 1, // 1基础2首营
        }).then((res) => {
          if (res.data.status === 200) {
            if (res.data.data) {
              if (res.data.data.originType === 1) {
                if (res.data.data.supplierInfo.status === 1) {
                  this.socialCodeModal = true;
                  this.socialCodeModalContent = '此供应商存在于基础供应商列表，是否引用。';// this.isInStore ? (`社会统一信用代码号:${value}已存在，是否进行引用？`) : (`社会统一信用代码号:${value}已存在，是否进行编辑？`);
                  this.tempForm = res.data.data.supplierInfo;
                } else {
                  this.disableItem = true;
                }
              } else {
                this.searchInfo = res.data.data.supplierInfo;
                if (res.data.data.supplierInfo.flowStatus === 2) {
                  this.inListInJudge = true;
                } else {
                  this.inList = true;
                }
              }
            }
            callback();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      }
      callback();
    },


    handleSearch() {
      const val = this.supplierForm.name;
      if (this.$route.name === 'supplierStoreEdit') {
        return;
      }
      this.nameList = [];
      if (val) {
        this.searchLoading = true;
        this.$store.commit('setDisableLoading', true);
        supplier.supplierGeneralNameCheck({ name: val ? val.slice(0, 100) : '' }).then((res) => {
          if (res.data.status === 200) {
            this.dropdownVisible = true;
            this.selectedIndex = 0;
            this.$emit('onNameChanged', val);
            res.data.data && res.data.data.forEach((element) => {
              this.nameList.push(element.baseInfo);
            });
          } else {
            this.$Message.error(res.data.error);
          }
          this.searchLoading = false;
        }).catch((err) => {
          this.searchLoading = false;
          utils.handleError(err);
        });
      }
    },

    handleSelectName(val) {
      this.searchInfo = val;

      supplier.supplierSocialCodeCheck({
        socialCode: this.searchInfo.socialUnifyCreditCode,
        originType: 2, // store2
      }).then((res) => {
        if (res.data.status === 200) {
          if (res.data.data.originType !== 1) {
            // 在首营库中，
            this.searchInfo = res.data.data.supplierInfo;
            if (res.data.data.supplierInfo.flowStatus === 2) {
              // 状态审批中，打开提示：审批中是否前往查看
              this.inListInJudge = true;
            } else {
              //
              this.inList = true;
            }
          } else {
            this.inBaseList = true;
          }
        } else {
          this.$Message.error(res.data.error);
        }
        // this.searchLoading = false;
      }).catch((err) => {
        // this.searchLoading = false;
        utils.handleError(err);
      });
    },
    inputBlur() {
      this.$nextTick(() => {
        this.dropdownVisible = false;
      });
    },
    onKeydown() {
    },
    focus() {
      this.$refs.search.focus();
    },
    seleced() {
      this.dropdownVisible = false;
      this.value = '';
      this.nameList[this.selectedIndex].socialUnifyCreditCode && this.handleSelectName(this.nameList[this.selectedIndex].socialUnifyCreditCode);
    },
    handleSearchKey(e) {
      if (this.dropdownVisible) {
        switch (e.key) {
          case 'ArrowDown':
            (this.selectedIndex < this.nameList.length - 1) && this.selectedIndex++;
            break;
          case 'ArrowUp':
            (this.selectedIndex > 0) && this.selectedIndex--;
            break;
          case 'Enter':
            this.seleced();
            break;
          default: break;
        }
      }
    },


    exchangeArr(data) {
      data.businessLicenceRange = [];
      data.drugProductRange = [];
      data.gmpRange = [];
      data.drugBusinessRange = [];
      data.gspRange = [];
      data.equipmentProdRange = [];
      data.thirdMediEquiRange = [];
      data.foodCredentailRange = [];
      data.foodBizRange = [];
      data.cosmeticCredentailRange = [];
      data.otherCredentailRange = [];
      data.otherLicense2Range = [];
      if (data.businessLicenceEffecivePeroid) {
        data.businessLicenceRange[0] = data.businessLicenceDate; // ? new Date(data.businessLicenceDate) : '';
        data.businessLicenceRange[1] = data.businessLicenceEffecivePeroid; // ? new Date(data.businessLicenceEffecivePeroid) : '';
      }
      if (data.drugProductEffecivePeroid) {
        data.drugProductRange[0] = data.drugProductDate; // ? new Date(data.businessLicenceDate) : '';
        data.drugProductRange[1] = data.drugProductEffecivePeroid; // ? new Date(data.businessLicenceEffecivePeroid) : '';
      }
      if (data.gmpEffecivePeroid) {
        data.gmpRange[0] = data.gmpCredentailDate; // ? new Date(data.gmpCredentailDate) : '';
        data.gmpRange[1] = data.gmpEffecivePeroid; // ? new Date(data.gmpEffecivePeroid) : '';
      }
      if (data.drugBusinessEffecivePeroid) {
        data.drugBusinessRange[0] = data.drugBusinessDate; // ? new Date(data.drugBusinessDate) : '';
        data.drugBusinessRange[1] = data.drugBusinessEffecivePeroid; // ? new Date(data.drugBusinessEffecivePeroid) : '';
      }
      if (data.gspEffecivePeroid) {
        data.gspRange[0] = data.gspCredentailDate; // ? new Date(data.gspCredentailDate) : '';
        data.gspRange[1] = data.gspEffecivePeroid; // ? new Date(data.gspEffecivePeroid) : '';
      }
      if (data.equipmentProdExpiry) {
        data.equipmentProdRange[0] = data.equipmentProdDate; // ? new Date(data.gspCredentailDate) : '';
        data.equipmentProdRange[1] = data.equipmentProdExpiry; // ? new Date(data.gspEffecivePeroid) : '';
      }
      // if (data.secondMediEquiCredDate) {
      //   data.secondMediEquiCredDate = new Date(data.secondMediEquiCredDate);
      // }
      if (data.thirdMediEquiEffecPeroid) {
        data.thirdMediEquiRange[0] = data.thirdMediEquiCredDate; // ? new Date(data.thirdMediEquiCredDate) : '';
        data.thirdMediEquiRange[1] = data.thirdMediEquiEffecPeroid; // ? new Date(data.thirdMediEquiEffecPeroid) : '';
      }
      if (data.foodEffecivePeroid) {
        data.foodCredentailRange[0] = data.foodCredentailDate; // ? new Date(data.foodCredentailDate) : '';
        data.foodCredentailRange[1] = data.foodEffecivePeroid; // ? new Date(data.foodEffecivePeroid) : '';
      }
      if (data.foodBizExpiry) {
        data.foodBizRange[0] = data.foodBizDate; // ? new Date(data.foodCredentailDate) : '';
        data.foodBizRange[1] = data.foodBizExpiry; // ? new Date(data.foodEffecivePeroid) : '';
      }
      if (data.cosmeticCredentailPeroid) {
        data.cosmeticCredentailRange[0] = data.cosmeticCredentailDate; // ? new Date(data.cosmeticCredentailDate) : '';
        data.cosmeticCredentailRange[1] = data.cosmeticCredentailPeroid; // ? new Date(data.cosmeticCredentailPeroid) : '';
      }
      if (data.otherCredentailPeroid) {
        data.otherCredentailRange[0] = data.otherCredentailDate; // ? new Date(data.otherCredentailDate) : '';
        data.otherCredentailRange[1] = data.otherCredentailPeroid; // ? new Date(data.otherCredentailPeroid) : '';
      }
      if (data.otherLicense2Expiry) {
        data.otherLicense2Range[0] = data.otherLicense2Date; // ? new Date(data.otherCredentailDate) : '';
        data.otherLicense2Range[1] = data.otherLicense2Expiry; // ? new Date(data.otherCredentailPeroid) : '';
      }
      const {
        provinceId, cityId, countyId, provinceName, cityName, countyName,
      } = data;
      if (provinceId && cityId && countyId) {
        data.locationArr = [provinceId, cityId, countyId];
      }
      if (provinceName && cityName && countyName) {
        data.locationStr = [provinceName, cityName, countyName].join('/');
      }
      // console.log(data);
    },
    importInfo() {
      if (this.isInStore) {
        this.importStoreinfo();
      } else {
        this.importBaseinfo();
      }
    },
    importBaseinfo() {
      this.socialCodeModal = false;
      if (!this.permissionFunc('supplierGeneralEdit')) {
        this.$Message.error('您没有权限编辑信息');
        return;
      }
      this.$store.commit('setLeaveModal', false);
      this.$nextTick(() => {
        this.$router.push({ name: 'supplierGeneralEdit', params: { id: this.tempForm.id } });
      });
    },
    importStoreinfo() {
      this.socialCodeModal = false;
      // for (const key in this.tempForm) {
      // if (key.includes('createTime') || key.includes('Peroid') || key.includes('Date')) {
      //   if (this.tempForm[key] && key !== 'secondMediEquiCredDate') {
      //     this.tempForm[key] = new Date(this.tempForm[key]);
      //   }
      // }
      // }
      this.tempForm.memoryCode = '';
      this.exchangeArr(this.tempForm);

      this.supplierForm = utils.deepClone(this.tempForm);
      this.supplierForm.enterpriseType = this.supplierForm.enterpriseType ? this.supplierForm.enterpriseType.split(',') : [];
      this.supplierForm.drugProdScopeIds = this.supplierForm.drugProdScopeIds ? this.supplierForm.drugProdScopeIds.split(',') : [];
      this.supplierForm.drugBizScopeIds = this.supplierForm.drugBizScopeIds ? this.supplierForm.drugBizScopeIds.split(',') : [];
      this.supplierForm.equipmentProdScopeIds = this.supplierForm.equipmentProdScopeIds ? this.supplierForm.equipmentProdScopeIds.split(',') : [];
      this.supplierForm.equipmentBizScopeIds = this.supplierForm.equipmentBizScopeIds ? this.supplierForm.equipmentBizScopeIds.split(',') : [];
      this.supplierForm.rigistryFund = '';
      this.supplierForm.refOriginId = this.supplierForm.id;
      this.supplierForm.id = '';
      this.supplierForm.area = '';
      this.supplierForm.postCode = '';
      for (const key in this.supplierForm) {
        if (key.includes('Range')) {
          if (!this.supplierForm[key][0]) {
            this.supplierForm[key] = [];
          }
        }
      }
      this.$emit('change', this.supplierForm);
      this.disableSocialUnifyCreditCode = true;
      this.disabelName = true;
    },
    inListInJudgeConfirm() {
      this.inListInJudge = false;
      this.$store.commit('setLeaveModal', false);

      this.$nextTick(() => {
        this.$router.push({ name: 'supplierStoreCheck', params: { id: this.searchInfo.id } });
      });
    },
    inListConfirm() {
      this.inList = false;
      this.$store.commit('setLeaveModal', false);
      this.$nextTick(() => {
        this.$router.push({ name: 'supplierStoreEdit', params: { id: this.searchInfo.id } });
      });
    },
    editInfoConfirm() {
      this.editInfo = false;
    },
    referenceConfirm() {
      // 引用基础库
      this.searchInfo.memoryCode = '';
      // console.log(utils.deepClone(this.searchInfo));
      this.exchangeArr(this.searchInfo);
      for (const key in this.searchInfo) {
        if (key.includes('Range')) {
          if (!this.searchInfo[key][0]) {
            this.searchInfo[key] = [];
          }
        }
      }
      this.$refs.supplierInfoCheck.resetFields();
      this.supplierForm.name = this.searchInfo.name;
      this.supplierForm.socialUnifyCreditCode = this.searchInfo.socialUnifyCreditCode;
      this.searchInfo.refOriginId = this.searchInfo.id;// 添加refOriginId转换为id逻辑
      this.searchInfo.rigistryFund = '';
      this.searchInfo.area = '';
      this.searchInfo.postCode = '';
      this.searchInfo.id = '';
      this.searchInfo.enterpriseType = this.searchInfo.enterpriseType ? this.searchInfo.enterpriseType.split(',') : [];
      this.searchInfo.drugProdScopeIds = this.searchInfo.drugProdScopeIds ? this.searchInfo.drugProdScopeIds.split(',') : [];
      this.searchInfo.drugBizScopeIds = this.searchInfo.drugBizScopeIds ? this.searchInfo.drugBizScopeIds.split(',') : [];
      this.searchInfo.equipmentProdScopeIds = this.searchInfo.equipmentProdScopeIds ? this.searchInfo.equipmentProdScopeIds.split(',') : [];
      this.searchInfo.equipmentBizScopeIds = this.searchInfo.equipmentBizScopeIds ? this.searchInfo.equipmentBizScopeIds.split(',') : [];
      this.$nextTick(() => {
        this.supplierForm = utils.deepClone(this.searchInfo);
        this.inBaseList = false;
        this.disableSocialUnifyCreditCode = true;
        this.$emit('change', this.supplierForm);
        this.$refs.supplierInfoCheck.$el.addEventListener('mouseup', this.handleClick);
      });
    },

    confirmClear() {
      this.$refs.supplierInfoCheck.resetFields();
      this.clearModal = false;
      this.inListInJudge = false;
      this.inList = false;
      this.disableItem = false;
      this.$nextTick(() => {
        this.nameList = [];
        this.disableSocialUnifyCreditCode = false;
        this.$store.commit('setLeaveModal', false);
      });
    },
    onNameChanged(e) {
      const name = e.target.value;
      this.$emit('onNameChanged', name);
    },
    handleForever(item, val) {
      this.supplierForm[item] = val;
    },
    validateForm(name) {
      return new Promise((resolve) => {
        let validate = true;

        this.$refs.supplierInfoCheck.validateField(name, (msg) => {
          if (msg) {
            validate = false;
          }
        });
        this.$nextTick(() => {
          resolve(validate);
        });
      });
    },
    validateSubmit() {
      return new Promise((resolve) => {
        this.$refs.supplierInfoCheck.validate((msg) => {
          resolve(msg && utils.handleExpire(this.$refs.supplierInfoCheck.$el));
        });
      });
    },
    // 进入编辑页时弹出需审批modal
    handleClick() {
      this.editInfo = true;
      this.$refs.supplierInfoCheck.$el.removeEventListener('mouseup', this.handleClick);
    },
    // 企业类型变化时，页面发生改变，需要重置快捷键名单
    enterpriseTypeChange() {
      this.$nextTick(() => {
        this.enterToTab();
      });
    },
    // 使用enter键进行表单切换
    enterToTab() {
      const visiableInput = [];
      const allInput = document.getElementsByClassName('supplierComponents')[0].getElementsByTagName('input');
      for (let i = 0; i < allInput.length; i++) {
        if (allInput[i].clientHeight && allInput[i].className !== 'ivu-checkbox-input' && allInput[i].className !== 'ivu-input ivu-input-default ivu-input-disabled'
        && allInput[i].className !== 'ivu-select-input') {
          visiableInput.push(allInput[i]);
        }
      }
      const count = visiableInput.length;
      visiableInput.forEach((item, index) => {
        item.onkeydown = (e) => {
          if (e.key === 'Enter') {
            let num = 1;
            if (index + num < count) {
              while (visiableInput[index + num].className === 'ivu-input ivu-input-default ivu-input-disabled') {
                num++;
              }
            }
            const nextEl = visiableInput[index + num];
            if (nextEl) {
              nextEl.focus();
            }
          }
        };
      });
    },
    // 组件内无法实现路由守卫，当父页面路由变化时触发
    handleRoute() {
      this.disableSocialUnifyCreditCode = !this.$route.name.endsWith('Add'); // 禁用社会统一信用码填写 新建可编辑
      this.disableCodeCheck = !this.$route.name.endsWith('Add'); // 禁用社会统一信用码检查 新建需检查

      if (this.$route.name === 'supplierStoreEdit') {
        this.$refs.supplierInfoCheck.$el.addEventListener('mouseup', this.handleClick);
      }
      this.$store.commit('setLeaveModal', false);// 从add跳转到edit需要重置setLeaveModal
    },
    // ifSelectRegistAddress(rule, value, callback) {
    //   console.log(value);
    //   if(this.supplierForm.locationArr) {
    //     callback(new Error('请选择包装单位'));
    //   } else {
    //     callback();
    //   }
    // }
  },
  created() {
    this.supplierForm = this.info;
    this.exchangeArr(this.supplierForm);

    if (!this.able) {
      this.supplierValidate = {};
    } else if (this.isInStore) {
      this.supplierForm.isAidOnly || (this.supplierForm.isAidOnly = 2);
      this.supplierValidate = {
        // 供应商信息
        rigistryFund: [
          { validator: utils.validate.rigistryFundValidator, trigger: 'change' },
        ],
        postCode: [
          { validator: utils.validate.postCodeValidator, trigger: 'change' },
        ],
        socialUnifyCreditCode: [
          { required: true, message: '此处为必填项，不能为空。', trigger: 'blur' },
          { validator: this.codeTest, trigger: 'blur' },
        ],
        name: [
          { required: true, message: '此处为必填项，不能为空。', trigger: 'change' },
        ],
        corporationPerson: [
          { required: true, message: '此处为必填项，不能为空。', trigger: 'change' },
        ],
        enterpriseType: [
          {
            required: true, message: '此处为必填项，不能为空。', trigger: 'change', type: 'array',
          },
        ],
        businessLicenceRange: [
          {
            required: true, message: '此处为必填项，不能为空。', trigger: 'change', type: 'array',
          },
        ],
        businessLicenceOffice: [
          { required: true, message: '此处为必填项，不能为空。', trigger: 'change' },
        ],
        locationArr: [
          {
            required: true, message: '此处为必填项，不能为空。', trigger: 'change', type: 'array',
          },
        ],
        memoryCode: [
          { required: true, message: '此处为必填项，不能为空。', trigger: 'change' },
        ],
        // 药品经营
        drugBizScopeIds: [
          {
            required: true, message: '此处为必填项，不能为空。', trigger: 'change', type: 'array',
          },
        ],
        drugBusinessCredentailCode: [
          { required: true, message: '此处为必填项，不能为空。', trigger: 'change' },
          // { validator: utils.validate.drugBusinessValidator, trigger: 'change' },
        ],
        drugBusinessRange: [
          {
            required: true, message: '此处为必填项，不能为空。', trigger: 'change', type: 'array',
          },
        ],
        drugBusinessOffice: [
          { required: true, message: '此处为必填项，不能为空。', trigger: 'change' },
        ],
        // gspCode: [
        //   { required: true, message: '此处为必填项，不能为空。', trigger: 'change' },
        // ],
        // gspRange: [
        //   {
        //     required: true, message: '此处为必填项，不能为空。', trigger: 'change', type: 'array',
        //   },
        // ],
        // gspCredentailOffice: [
        //   { required: true, message: '此处为必填项，不能为空。', trigger: 'change' },
        // ],
        // 药品生产
        drugProdScopeIds: [
          {
            required: true, message: '此处为必填项，不能为空。', trigger: 'change', type: 'array',
          },
        ],
        drugProductRange: [
          {
            required: true, message: '此处为必填项，不能为空。', trigger: 'change', type: 'array',
          },
        ],
        drugProductCredentailCode: [
          { required: true, message: '此处为必填项，不能为空。', trigger: 'change' },
        ],
        drugProductOffice: [
          { required: true, message: '此处为必填项，不能为空。', trigger: 'change' },
        ],
        // gmpCode: [
        //   { required: true, message: '此处为必填项，不能为空。', trigger: 'change' },
        // ],
        // gmpRange: [
        //   {
        //     required: true, message: '此处为必填项，不能为空。', trigger: 'change', type: 'array',
        //   },
        // ],
        // gmpCredentailOffice: [
        //   { required: true, message: '此处为必填项，不能为空。', trigger: 'change' },
        // ],
        // 食品信息
        foodBizCode: [
          { required: true, message: '此处为必填项，不能为空。', trigger: 'change' },
        ],
        foodBizRange: [
          {
            required: true, message: '此处为必填项，不能为空。', trigger: 'change', type: 'array',
          },
        ],
        foodBizOffice: [
          { required: true, message: '此处为必填项，不能为空。', trigger: 'change' },
        ],
        // 设备生产信息
        equipmentProdScopeIds: [
          {
            required: true, message: '此处为必填项，不能为空。', trigger: 'change', type: 'array',
          },
        ],
        equipmentProdRange: [
          {
            required: true, message: '此处为必填项，不能为空。', trigger: 'change', type: 'array',
          },
        ],
        equipmentProdOffice: [
          { required: true, message: '此处为必填项，不能为空。', trigger: 'change' },
        ],
        equipmentProdCode: [
          { required: true, message: '此处为必填项，不能为空。', trigger: 'change' },
        ],
        // 设备经营信息
        equipmentBizScopeIds: [
          {
            required: true, message: '此处为必填项，不能为空。', trigger: 'change', type: 'array',
          },
        ],
        // 详细信息
        depositBank: [
          {
            required: true, message: '此处为必填项，不能为空。', trigger: 'change',
          },
        ],
        qualityEnsureEffecivePeroid: [
          {
            required: true, message: '此处为必填项，不能为空。', trigger: 'change', type: 'number',
          },
        ],
        // authorizerName: [
        //   {
        //     required: true, message: '此处为必填项，不能为空。', trigger: 'change',
        //   },
        // ],
        authorizerEffecivePeroid: [
          {
            required: true, message: '此处为必填项，不能为空。', trigger: 'change', type: 'number',
          },
        ],
        depositaryName: [
          {
            required: true, message: '此处为必填项，不能为空。', trigger: 'change',
          },
        ],
        depositaryIdCard: [
          {
            required: true, message: '此处为必填项，不能为空。', trigger: 'change',
          },
          { validator: utils.validate.IDValidator, trigger: 'change' },
        ],
        depositaryIdEffecivePeroid: [
          {
            required: true, message: '此处为必填项，不能为空。', trigger: 'change', type: 'number',
          },

        ],
        puchasePersonSuggestion: [
          {
            required: true, message: '此处为必填项，不能为空。', trigger: 'change',
          },

        ],
        bankAccount: [
          {
            required: true, message: '此处为必填项，不能为空。', trigger: 'change',
          },
          {
            validator: this.bankAccountTest, trigger: 'change',
          },
        ],
        accountProid: [
          {
            validator: utils.validate.numberRange, params: { min: 0 }, trigger: 'change',
          },
        ],
        creditLimit: [
          {
            validator: utils.validate.numberRange, params: { min: 0 }, trigger: 'change',
          },
        ],
      };
      this.handleAidDrugChange(this.supplierForm.isAidOnly);// 处理初始必填校验
    } else {
      this.supplierValidate = {
        // 供应商信息
        name: [
          { required: true, message: '此处为必填项，不能为空。', trigger: 'change' },
        ],
        socialUnifyCreditCode: [
          { required: true, message: '此处为必填项，不能为空。', trigger: 'blur' },
          { validator: this.codeTest, trigger: 'blur' },
        ],
        locationArr: [
          {
            required: true, message: '此处为必填项，不能为空。', trigger: 'change', type: 'array',
          },
        ],
        memoryCode: [
          { required: true, message: '此处为必填项，不能为空。', trigger: 'change' },
        ],
      };
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.handleRoute();
      this.enterToTab();

      // 控制监听表单数据，变化setLeaveModal=true
      this.setLeave = true;
    });
  },
};
</script>

<style lang="less" scoped>
.cardContainer{
  margin-bottom: 12px
}
.rowTop {
  margin-top: -270px;
}
.demo-auto-complete-item{
  width: 650px;
  max-height: 500px
}
.searchItem{
    display: inline-block;
    width: 25%;
    word-wrap: none;
    text-overflow: ellipsis;
    overflow: hidden;
}
.noTitle{
  .noThing{
    height: 36px;
    line-height: 36px;
    padding-left: 16px;
    color: rgba(0, 0, 0, 0.25)
  }
}
// .label{
//   text-align-last: right;
//   text-align: right;
//   margin-left: -178px;
//   width: 170px;
//   float: left;
//   line-height: 1;
// }
// .searchList{
//   max-height: 300px;
//   overflow: auto
// }
// .selected{
//   background: #f8f8f8
// }
// .options{
//   display: flex;
//   align-items: left;
//   font-size: 12px;
//   >span{
//     text-align: left;
//     word-wrap: none;
//     text-overflow: ellipsis;
//     overflow: hidden;
//   }
//   >span:nth-child(2){
//     width: 180px;
//   }
//   >span:nth-child(3){
//     width: 100px;
//   }
//   .textOver{
//     width: 100%;
//     text-align: center;
//     word-wrap: none;
//     text-overflow: ellipsis;
//     overflow: hidden;
//   }
// }
  // .enterpriseTypeClass {
  //   .ivu-checkbox-group{
  //     width: 435px;
  //   }

  // }
  .enterpriseTypeClass label{
    margin-right: 28px
  }

</style>
